// extracted by css-extract-rspack-plugin
export default {"footer":"kG1_WHf4UiAqM4bo"};